var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgContact = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.027,
    height: 15.023,
    viewBox: "0 0 22.027 15.023",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -3.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.028,3.8h0A2.387,2.387,0,0,0,0,6.2v4.055H0v5.622H1.014V10.251h0V6.2a1.933,1.933,0,0,1,.369-1.014c.369.276,9.585,7.926,9.585,7.926L21.013,4.814V16.426a1.389,1.389,0,0,1-1.106,1.382H0v1.014H20a2.26,2.26,0,0,0,2.028-2.4V3.8Zm8.94,8.018-8.387-7H19.539Z",
    transform: "translate(0 0)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContact, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contact.b52f8ab8.svg";
export { ForwardRef as ReactComponent };